import { EventsSlider } from 'react-scale/components/pages/events/slider';
import * as React from 'react';
import { getEventDays, BuilderEvent, ImageProps } from '../utils';
import s from './details.module.css';
import clsx from 'clsx';
import Link from 'next/link';
import CTA from 'react-scale/components/elements/cta';
import { CTA as CTAType } from 'react-scale/components/sections/hero/centralized-hero';
import Section from 'react-scale/components/elements/section';

type Props = {
  event: BuilderEvent;
  cta?: CTAType;
};

export const EventsHero = ({ event, cta }: Props) => {
  const eventDays = React.useMemo(
    () => getEventDays(event.value.data.startDate, event.value.data.endDate),
    []
  );

  const eventIsUpcoming = React.useMemo(
    () => new Date(event.value.data.startDate).getTime() > new Date().getTime(),
    [event.value.data.startDate]
  );

  return (
    <Section paddingTop={false} paddingBottom={false}>
      <div className="relative flex items-center flex-col font-aeonik gap-5 lg:mt-[110px] text-center">
        <Link
          href="/events"
          className="self-start md:absolute font-inter font-bold top-0 left-0 w-fit"
        >
          ← Back
        </Link>
        <span className="uppercase mb-1 font-body text-gradient">
          {eventIsUpcoming ? 'UPCOMING EVENT' : 'PAST EVENT'}
        </span>
        <h1 className="text-4xl">{event.value.data.title}</h1>
        <span className="text-[#BBDEF2] text-xl">{eventDays}</span>
        {/* @ts-ignore: Unreachable code error */}
        {cta && <CTA cta={cta} />}
      </div>
    </Section>
  );
};

type EventDetailsProps = {
  content: string;
  images: ImageProps[];
};

export const EventsDetails = (props: EventDetailsProps) => {
  return (
    <>
      <EventsSlider images={props.images} />
      <div
        className={clsx(s.content, 'lg:max-w-[40vw] mt-[83px] mb-10 mx-auto font-body')}
        dangerouslySetInnerHTML={{ __html: props.content }}
      ></div>
    </>
  );
};
